export type TenantLabel = string;

export const TenantLabel = {
	EMCloudAD: 'd1ee1acd-bc7a-4bc4-a787-938c49a83906',
	ExxonMobilTest: '7784e57e-9269-47d7-9fd8-b18763f7fec3',
};